import { render, staticRenderFns } from "./MensagemEmailSignatarioNovo.vue?vue&type=template&id=095aabca"
import script from "./MensagemEmailSignatarioNovo.vue?vue&type=script&lang=js"
export * from "./MensagemEmailSignatarioNovo.vue?vue&type=script&lang=js"
import style0 from "./MensagemEmailSignatarioNovo.vue?vue&type=style&index=0&id=095aabca&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports